module.exports = __webpack_public_path__ + "static/media/vineyard.ceb8a98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vineyard.jpg
// module id = 55
// module chunks = 0